import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';
import VideoCard from '@/components/feature/VideoCard';

interface VideoSectionProps {
  title: string;
  subtitle?: string;
  videos: Array<{
    id: number;
    title: string;
    category: string;
    year: number;
    rating: number;
    posterUrl: string;
    status: string;
  }>;
  viewAllLink?: string;
  viewAllText?: string;
}

export default function VideoSection({ title, subtitle, videos, viewAllLink, viewAllText }: VideoSectionProps) {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-end justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">{title}</h2>
            {subtitle && (
              <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>{viewAllText || '查看全部'}</span>
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-5">
          {videos.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              category={video.category}
              year={video.year}
              rating={video.rating}
              posterUrl={video.posterUrl}
              status={video.status}
              categoryName={categories.find(c => c.id === video.category)?.name || ''}
            />
          ))}
        </div>
      </div>
    </section>
  );
}